import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconCheckStyle0 = gravityIconIndividualCss;

const GravityIconCheck = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '98d4d6405806096af7d43d61d3ca14739eb30c38', color: this.color, size: this.size }, h("svg", { key: '9697cababccaf04385aae60995f72c912738f43b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'a13756e80db7e3637e00d18a89da644f76eca892', d: "M7.717 17.999a.571.571 0 0 1-.422-.145L2.19 13.279a.568.568 0 0 1-.043-.804l.382-.424a.573.573 0 0 1 .808-.043l4.279 3.834L18.594 4.18a.574.574 0 0 1 .808-.026l.417.39c.23.215.242.576.026.805L8.107 17.82a.57.57 0 0 1-.39.18Z", fill: "currentColor" }))));
    }
};
GravityIconCheck.style = GravityIconCheckStyle0;

export { GravityIconCheck as gravity_icon_check };

//# sourceMappingURL=gravity-icon-check.entry.js.map